import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import useSWR from 'swr';
import { ref, getDatabase, off, onValue, update } from 'firebase/database';
import {
  CircularProgress as MuiCircularProgress,
  withStyles,
} from '@material-ui/core';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import CloseIcon from '@material-ui/icons/Close';
import { dataFetcher, endpoints, axios, baseUrl } from 'Api';
import RightArrowImg, {
  ReactComponent as RightArrow,
} from 'Assets/category-right-arrow.svg';
import LeftArrowImg, {
  ReactComponent as LeftArrow,
} from 'Assets/category-left-arrow.svg';
import { ProfilePage, ProjectorShimmer } from 'Components';
// import { ApolloClient, InMemoryCache } from '@apollo/client';
import { AppContext, AuthContext } from 'Context';
import { Pathname } from 'Routes';
import ImageGroup from 'Components/ImageGroup/ImageGroup';
import ViewMyProjector from 'Components/ImageGroup/ViewMyProjector';
import PermissionDeniedModal from 'Components/PermissionDeniedModal';
import { getUserContents } from 'Api/apiFunctions';
import useMyAxios from 'hooks/useMyAxios';
import FixedProgressBar from 'Components/header/components/FixedProgressBar';
import DelayedProgressBar from 'Components/DelayedProgressBar';
import ThreeDotLoader from 'Components/ThreeDotLoader';
import { WhatsNew } from '../my-profile/Component/WhatsNew/whatsNew';
import { ImageBanner } from '../my-profile/Component/ImageBanner/imageBanner';
import { AlbumBanner } from '../my-profile/Component/AlbumBanner/albumBanner';
import BottomBar from './BottomBar';
// eslint-disable-next-line
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line
import "swiper/swiper-bundle.min.css"; // ✅ Import full Swiper styles
// eslint-disable-next-line
import SwiperCore, { Navigation, Pagination } from "swiper/core";
import styles from './index.module.css';

SwiperCore.use([Navigation, Pagination]);
const CircularProgress = withStyles({
  circle: {
    color: '#fff !important',
  },
})(MuiCircularProgress);

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1.5,
    slidesToSlide: 1, // optional, default to 1.
  },
};
const isTrueValue = true;

const CustomRightArrow = ({ onClick, layoutType }) => (
  <RightArrow
    fontSize="large"
    onClick={onClick}
    aria-label="Go to next slide"
    className={
      layoutType === 3 || layoutType === 4
        ? 'react-multiple-carousel__arrow react-multiple-carousel__arrow--rightx layout_arrow_category'
        : 'react-multiple-carousel__arrow react-multiple-carousel__arrow--rightx custom_arrow_category'
    }
  />
);

const CustomLeftArrow = ({ onClick, layoutType }) => (
  <LeftArrow
    onClick={onClick}
    aria-label="Go to next slide"
    className={
      layoutType === 3 || layoutType === 4
        ? 'react-multiple-carousel__arrow react-multiple-carousel__arrow--leftx layout_arrow_category'
        : 'react-multiple-carousel__arrow react-multiple-carousel__arrow--leftx custom_arrow_category'
    }
  />
);
export const CONTENT_TYPES = {
  categories: 'categories',
  photo_albums: 'photo_album',
  playlists: 'playlists',
  resume: 'Resume Watching',
  first15Videos: 'First 15 Videos',
};

export const Profile = () => {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const navigate = useNavigate();
  const {
    setAppSnackbar,
    userDetails,
    contextLoading,
    setContextLoading,
    setLoadingState,
    langText,
    dataOfCategory,
    setdataOfCategory,
    profileName,
    setProfileName,
    amICalled,
    setTopOrBottom,
    setcategoryLoader,
    loader,
    setLoader,
    categoryLoader,
    profileLoader,
    projectorOwner,
    profileDetails,
    setNeedToShowETA,
    firebaseDatabase,
    backendUrl,
    orderArrange,
    fetchLayoutOrder,
    subscriptionDetails,
  } = useContext(AppContext);
  useEffect(() => {
    sessionStorage.setItem('navigateProfile', window.location.pathname);
  }, [window.location.pathname]);
  const { getToken, isInActiveUser } = useContext(AuthContext);
  const urlParams = useParams();
  const profileID = urlParams?.profileID || userDetails.myId;
  const isMyProfile = !urlParams?.profileID;
  const profileText = langText?.viewProjector;
  const scrollPageRef = useRef(null);
  const [selectedCategoryID, setSelectedCategoryID] = useState(undefined);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [loading, setLoading] = useState(true);
  const [shimmerLoading, setShimmerLoading] = useState(true);
  const [profileHeroImage, setProfileHeroImage] = useState(undefined);
  const [resumeWatching, setResumeWatching] = useState([]);
  const [resumeMe, setResumeMe] = useState();
  const [first15Videos, setFirst15Videos] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  // Debug: Log when modal state changes
  useEffect(() => {
    console.log('🔵 showPermissionModal changed to:', showPermissionModal);
  }, [showPermissionModal]);
  const [playlist, setPlaylist] = useState();
  const [categories, setCategories] = useState([]); // categories box on top
  const [subCategories, setSubCategories] = useState([]);
  const [allVideos, setAllVideos] = useState([]);
  const [orderedData, setOrderedData] = useState(undefined);
  const [selectedCategoryTitle, setSelectedCategoryTitle] = useState(undefined);
  const [showArrow, setArrows] = useState(false);
  const [isPublicUser, setPublicUser] = useState(false);
  const [layoutType, setLayoutType] = useState(1);
  const [layoutData, setLayoutData] = useState(undefined);
  const [haveData, checkData] = useState(undefined);
  const [categoryStyleId, setCategoryStyleId] = useState(undefined);
  const [thumbnail, setThumbnail] = useState(undefined);
  const limit = 70; // categories video content limit
  const [start, setStart] = useState(1);
  const [startPL, setStartPL] = useState(1);
  const content_limit = 25; // photo albums limts & categories list limit
  const [content_start, setContentStart] = useState(1);
  const [content_startPL, setContentStartPL] = useState(1);
  const [basicData, setBasicData] = useState();
  const [contentData, setContentData] = useState([]);
  const [playlistData, setPlaylistData] = useState([]);
  const [albumData, setAlbumData] = useState([]);
  const [categoriPagination, setCategoriPagination] = useState([]);
  const [playlistPagination, setPlaylistPagination] = useState([]);
  const [albumPagination, setAlbumPagination] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasContent, setHasContent] = useState(false);
  const [videoOffset, setVideoOffset] = useState({});
  const [isFetching, setIsFetching] = useState(false); // Tracks if a fetch is in progress
  const fetchQueue = useRef([]); // Queue to store pending fetch requests'
  const promiseLock = useRef();
  useEffect(() => {
    if (!subscriptionDetails || !subscriptionDetails.plans) return;

    const lastPlan = subscriptionDetails.plans[subscriptionDetails.plans.length - 1];

    const shouldRedirect = isInActiveUser && lastPlan?.is_trial === '0';
    // || subscriptionDetails?.current_plan === 'Free'
    // || subscriptionDetails?.subscription === null

    if (shouldRedirect) {
      navigate('/dashboard');
    }
  }, [isInActiveUser, subscriptionDetails, navigate]);
  useEffect(() => {
    setTopOrBottom(false);
  }, []);

  const [endLoader, setEndLoader] = useState(false);

  const fetchData = async (pageOffset, category_id, categoryVideoOffset) => {
    try {
      const api = `${backendUrl}/graphql`;
      const query = 'query GetCategories($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $commonVideoLimit: Int, $categoryVideoPagination: [CategoryVideoPaginationInput]) { categories(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, commonVideoLimit: $commonVideoLimit, categoryVideoPagination: $categoryVideoPagination) { categories { category_id category_name icon videos { id title thumbnails visibility } videoPagination { total limit offset hasNextPage hasPreviousPage } } pagination { total limit offset hasNextPage hasPreviousPage } } }';

      const variables = {
        userId: Number(profileID),
        limit: 10,
        offset: pageOffset,
        commonVideoLimit: 10,
        categoryVideoPagination: category_id
          ? [
            {
              categoryId: category_id,
              videoLimit: 10,
              videoOffset: categoryVideoOffset,
            },
          ]
          : [],
      };

      const response = await axios.post(
        api,
        { query, variables },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      const newData = response?.data?.data?.categories?.categories || [];
      const isPagination = response?.data?.data?.categories?.pagination;
      setCategoriPagination(isPagination);

      if (category_id) {
        // this is for each category
        setContentData((prevData) => prevData?.map((category) => {
          const newCategoryData = newData?.find(
            (c) => c?.category_id === category?.category_id
          );

          if (newCategoryData) {
            const existingVideoIds = new Set(
              category?.videos?.map((v) => v?.id)
            );
            return {
              ...category,
              videos: [
                ...category?.videos,
                ...newCategoryData?.videos?.filter(
                  (video) => !existingVideoIds?.has(video?.id)
                ),
              ],
              videoPagination: newCategoryData?.videoPagination,
            };
          }
          return category;
        }));
      } else {
        // this is for whole category
        setContentData((prevData) => {
          const existingCategoryIds = new Set(
            prevData.map((item) => item?.category_id)
          );
          const uniqueNewData = newData?.filter(
            (item) => !existingCategoryIds.has(item?.category_id)
          );
          const combinedData = [...prevData, ...uniqueNewData];

          // Sort to ensure "All videos" is always first
          return combinedData.sort((a, b) => {
            const aIsAllVideos = a?.category_name?.toLowerCase() === 'all videos';
            const bIsAllVideos = b?.category_name?.toLowerCase() === 'all videos';

            if (aIsAllVideos) return -1;
            if (bIsAllVideos) return 1;

            return 0; // Keep original order for others
          });
        });
      }

      setcategoryLoader(false);
      setEndLoader(false);
    } catch (error) {
      setEndLoader(false);
      console.error('GraphQL Error:', error);
      setcategoryLoader(false);
    } finally {
      // Release the lock by resolving the current promise
      if (promiseLock.current) {
        promiseLock.current.resolve();
        promiseLock.current = null;
      }
    }
  };
  const fetchPlaylistData = async (
    pageOffset,
    playlist_id,
    categoryVideoOffset
  ) => {
    try {
      const api = `${backendUrl}/get-videos-by-playlist`;
      const query = 'query GetPlaylists($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int, $commonVideoLimit: Int, $playlistVideoPagination: [PlaylistVideoPaginationInput]) { playlists(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset, commonVideoLimit: $commonVideoLimit, playlistVideoPagination: $playlistVideoPagination) { playlists { playlist_id playlist_title videos { id title thumbnails visibility } videoPagination { total limit offset hasNextPage hasPreviousPage } } pagination { total limit offset hasNextPage hasPreviousPage } } }';

      const variables = {
        userId: Number(profileID),
        limit: 10,
        offset: pageOffset, // ✅ Only use this for page scrolling
        commonVideoLimit: 10,
        playlistVideoPagination: playlist_id
          ? [
            {
              playlistId: playlist_id,
              videoLimit: 10,
              videoOffset: categoryVideoOffset,
            },
          ] // ✅ Use category-specific offset
          : [],
      };

      const response = await axios.post(
        api,
        { query, variables },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      const newData = response?.data?.data?.playlists?.playlists || [];
      const isPagination = response?.data?.data?.playlists?.pagination;
      setPlaylistPagination(isPagination);
      if (playlist_id) {
        setPlaylistData((prevData) => prevData.map((category) => {
          const newCategoryData = newData.find(
            (c) => c.playlist_id === category.playlist_id
          );

          if (newCategoryData) {
            const existingVideoIds = new Set(
              category.videos.map((v) => v.id)
            ); // ✅ Collect existing video IDs
            return {
              ...category,
              videos: [
                ...category.videos,
                ...newCategoryData.videos.filter(
                  (video) => !existingVideoIds.has(video.id)
                ), // ✅ Append only unique videos
              ],
              videoPagination: newCategoryData.videoPagination, // ✅ Update pagination info
            };
          }
          return category;
        }));
      } else {
        setPlaylistData((prevData) => {
          const existingCategoryIds = new Set(
            prevData.map((item) => item.playlist_id)
          );
          const uniqueNewData = newData.filter(
            (item) => !existingCategoryIds.has(item.playlist_id)
          );
          return [...prevData, ...uniqueNewData]; // Append only unique categories
        });
      }

      setcategoryLoader(false);
      setEndLoader(false);
    } catch (error) {
      setEndLoader(false);
      console.error('GraphQL Error Playlist:', error);
      setcategoryLoader(false);
    }
  };
  const fetchPhotoAlbumData = async (pageOffset) => {
    try {
      const api = `${backendUrl}/get-albums`;
      const query = 'query GetAlbums($userId: Int!, $tokenUserId: Int!, $limit: Int, $offset: Int) { albums(userId: $userId, tokenUserId: $tokenUserId, limit: $limit, offset: $offset) { albums { id title description icon } pagination { total limit offset hasNextPage hasPreviousPage } } }';

      const variables = {
        userId: Number(profileID),
        limit: 10,
        offset: pageOffset, // ✅ Only use this for page scrolling
      };
      const response = await axios.post(
        api,
        { query, variables },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      const newData = response?.data?.data?.albums?.albums || [];
      const isPagination = response?.data?.data?.albums?.pagination;
      setAlbumPagination(isPagination);
      setAlbumData((prev) => {
        const prevIds = new Set(prev.map((v) => v.id));
        const filtered = newData.filter((v) => !prevIds.has(v.id));
        return [...prev, ...filtered]; // ✅ same reference for unchanged items
      });
    } catch (error) {
      setEndLoader(false);
      console.error('GraphQL Error album:', error);
    }
  };
  const processQueue = () => {
    if (fetchQueue.current.length === 0 || promiseLock.current) return;

    const { pageOffset, category_id, categoryVideoOffset } = fetchQueue.current.shift();

    // Create a new promise to lock the process
    promiseLock.current = {};
    promiseLock.current.promise = new Promise((resolve) => {
      promiseLock.current.resolve = resolve;
    });

    fetchData(pageOffset, category_id, categoryVideoOffset).then(() => {
      processQueue(); // Process the next item after the current one resolves
    });
  };

  // Add a fetch request to the queue
  const queueFetchData = (pageOffset, category_id, categoryVideoOffset) => {
    fetchQueue.current.push({ pageOffset, category_id, categoryVideoOffset });
    if (!promiseLock.current) {
      processQueue(); // Start processing if no lock is active
    }
  };
  const [categoryOffset, setCategoryOffset] = useState(0);
  const [playlistOffset, setPlaylistOffset] = useState(0);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.offsetHeight;

    const scrollPercentage = (scrollTop + windowHeight) / documentHeight;

    if (scrollPercentage >= 0.5) {
      if (categoriPagination?.hasNextPage) {
        setEndLoader(true);
        setCategoryOffset((prevOffset) => {
          const newOffset = prevOffset + 10;
          queueFetchData(newOffset, null, null);
          return newOffset;
        });
      }

      // Handle playlist pagination if needed (same queue logic)
      if (playlistPagination?.hasNextPage) {
        setEndLoader(true);
        setPlaylistOffset((prevOffset) => {
          const newOffset = prevOffset + 10;
          fetchPlaylistData(newOffset, null, null);
          return newOffset;
        });
      }
    }
  };
  const addMoreContents = () => {
    if (categoriPagination?.hasNextPage) {
      setCategoryOffset((prev) => {
        const newOffset = prev + 10;
        fetchData(newOffset, null, null);
        return newOffset;
      });
    }

    if (playlistPagination?.hasNextPage) {
      setPlaylistOffset((prev) => {
        const newOffset = prev + 10;
        fetchPlaylistData(newOffset, null, null);
        return newOffset;
      });
    }
  };
  // Attach scroll listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [categoriPagination?.hasNextPage]); // ✅ Dependency added
  const fetchResumeData = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/v1/getUserContentsResumes`,
        {
          user_id: profileID,
        }
      );
      setResumeMe(response?.data);
      // setcategoryLoader(false);
    } catch (error) {
      const responseData = error?.response?.data;
      // setcategoryLoader(false);
    }
  };
  const fetchFirstFiles = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/${endpoints.getFirstFiles}`,
        {
          token: getToken(),
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );

      // Store allowed video and album IDs in localStorage for permission checking
      if (response?.data?.success && response?.data?.data) {
        const { videos, albums } = response.data.data;

        // Extract video IDs
        if (Array.isArray(videos)) {
          const allowedVideoIds = videos.map((video) => String(video.id));
          localStorage.setItem('allowedVideoIds', JSON.stringify(allowedVideoIds));
        }

        // Extract album IDs
        if (Array.isArray(albums)) {
          const allowedAlbumIds = albums.map((album) => String(album.id));
          localStorage.setItem('allowedAlbumIds', JSON.stringify(allowedAlbumIds));
        }
      }

      setFirst15Videos(response?.data);
    } catch (error) {
      const responseData = error?.response?.data;
    }
  };
  const callForUpdate = () => {
    const apiUrl = `${baseUrl}/v1/loadUserContents`;
    const postData = {
      token: getToken(),
      user_id: profileID,
      pass_from: 'web on payload',
    };
    axios
      .post(apiUrl, postData)
      .then((response) => response.data)
      .catch((error) => {
        console.error('err', error);
      });
  };
  useEffect(() => {
    // if (!orderArrange?.[profileID] || orderArrange?.[profileID].length === 0) {
    //   fetchLayoutOrder(Number(profileID));
    // }
    fetchLayoutOrder(Number(profileID));
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      setcategoryLoader(true);
      setLoader(true);

      // Reset states
      setPlaylistData([]);
      setAlbumData([]);
      setContentData([]);
      setOffset(0);

      try {
        // Run all API calls in parallel
        await Promise.all([
          fetchData(0),
          fetchPlaylistData(0),
          fetchPhotoAlbumData(0),
          fetchResumeData(),
          fetchFirstFiles(),
        ]);
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoader(false);
      }
    };

    fetchAllData();
  }, [profileID]);

  const path = window.location.origin === 'https://projector.app'
    ? 'projector_contents'
    : 'pre_projector_contents';
  useEffect(() => {
    const databaseRefGetVideos = ref(
      firebaseDatabase,
      `${path}/${localStorage.getItem('id')}`
    );
    const dataCallbackVideos = (snapshot) => {
      if (snapshot.exists()) {
        // fetchResumeData();
        fetchData(offset);
        fetchPlaylistData(offset);
      }
    };
    onValue(databaseRefGetVideos, dataCallbackVideos);
    return () => {
      off(databaseRefGetVideos, 'value', dataCallbackVideos);
    };
  }, []);
  const { mutate: getMyPausedList } = useSWR(
    [endpoints.getMyPausedList, profileID],
    {
      fetcher: (url, user_id) => dataFetcher(url, { user_id }),
      onSuccess: ({ success, paused, message }) => {
        if (success) {
          setcategoryLoader(false);
        } else {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message: message || 'Oops! Something went wrong',
          });
        }
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        const responseData = error?.response?.data;
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: responseData?.message || 'Oops! Something went wrong',
        });
      },
    }
  );
  const { mutate: clearResumeWatching } = useSWR(
    [endpoints.clearResumeList, profileID],
    {
      fetcher: (url, user_id) => dataFetcher(url, { user_id }),
      onSuccess: ({ success, message }) => {
        if (success) {
          fetchResumeData();
          // fetchData();
          getMyPausedList();
        } else {
          setAppSnackbar({ isVisible: true, type: 'error', message });
        }
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message:
            error?.response?.data?.message || 'Oops! Something went wrong',
        });
      },
    }
  );

  useEffect(() => {
    getMyPausedList();
  }, [profileID]);

  useEffect(() => {
    setNeedToShowETA(false);
    setTimeout(() => {
      if (contextLoading) {
        setContextLoading(false);
      }
    }, 3000);
  }, []);

  // const uniqueContentTypes = contentData?.data?.map((item) => item?.content_type);

  const uniqueContentTypes = Array.isArray(contentData?.data)
    ? contentData.data
      .sort((a, b) => (a?.order_number || 0) - (b?.order_number || 0))
      .map((item) => item?.content_type)
    : [];

  // Function to check if any content data is non-empty
  const checkContent = (content, playlist, album) => {
    const hasData = (input) => Array.isArray(input?.data)
      && input.data.some(
        (item) => Array.isArray(item?.data) && item.data.length > 0
      );

    return hasData(content) || hasData(playlist) || hasData(album);
  };

  useEffect(() => {
    setHasContent(checkContent(contentData, playlistData, albumData));
  }, [contentData, playlistData, albumData]);
  // useEffect(() => {
  //   if (contentData || playlistData || albumData) {
  //     setLoader(false);
  //   }
  // }, [hasContent, setLoading]);

  const categoryHead = Array.isArray(contentData?.data)
    ? contentData.data.find((item) => item?.content_type === 'categories')?.data
    : undefined;
  const defaultOrder = [
    { content_type_id: 1, order_number: 1 },
    { content_type_id: 2, order_number: 2 },
    { content_type_id: 3, order_number: 3 },
  ];

  // Get the user's layout order or fallback
  const profileOrder = orderArrange?.[Number(profileID)]?.length
    ? [...orderArrange[Number(profileID)]]
    : defaultOrder;

  // Config map
  const contentTypeMap = {
    1: {
      fetchData,
      offset,
      responseData: contentData,
      type: CONTENT_TYPES.categories,
      pagination: categoriPagination,
    },
    2: {
      fetchData: fetchPlaylistData,
      offset,
      responseData: playlistData,
      type: CONTENT_TYPES.playlists,
      pagination: playlistPagination,
    },
    3: {
      fetchData: fetchPhotoAlbumData,
      offset,
      responseData: albumData,
      type: CONTENT_TYPES.photo_albums,
      albumPagination,
      profileDetails: profileDetails?.firstname,
    },
  };
  // const navigationConfig = {};
  // if (video.haspre) navigationConfig.prevEl = '#custom-prev';
  // if (video.hasnext) navigationConfig.nextEl = '#custom-next';
  const slidesPerView = window.innerWidth >= 640 ? 4 : 3;
  const hasScrollableSlides = contentData?.length > slidesPerView;
  const [swiperStates, setSwiperStates] = useState({
    atBeginning: true,
    atEnd: false,
    hasScrollableSlides: false,
  });
  const updateSwiperStates = (swiper) => {
    setSwiperStates({
      atBeginning: swiper.isBeginning,
      atEnd: swiper.isEnd,
      hasScrollableSlides: swiper.slides.length > swiper.params.slidesPerView,
    });
  };
  console.log(
    'hasScrollableSlides',
    swiperStates?.atEnd,
    categoriPagination?.hasNextPage
  );
  return (
    <>
      {loader && <FixedProgressBar />}
      <BottomBar />
      {categoryLoader === true ? (
        <FixedProgressBar />
      ) : (
        <ProfilePage
          containerClassName={cn({
            [styles.pageContainer]: true,
            [styles.pageContainerVideoBanner]: layoutType === 4,
          })}
          mainClassName={cn({
            [styles.mainContent]: true,
            [styles.loading]: loading,
          })}
          userName={profileName}
          isProfileHeader
          userProfileLink={Pathname.getFriendProfilePath(profileID)}
          videoBanner={layoutType === 4}
          layoutData={layoutData}
        >
          {profileLoader === true && categoryLoader === true ? (
            <div className={styles.ending}>
              <ThreeDotLoader />
            </div>
          ) : (
            // <div className={styles.headingText}>
            //   {profileDetails?.firstname === 'Tutorials'
            //     ? profileDetails?.firstname
            //     : `${profileDetails?.firstname?.trim()}'s Projector`}
            // </div>
            <div>
              <div className={styles.headingText}>
                {profileDetails?.firstname
                  ? profileDetails.firstname === 'Tutorials'
                    ? 'Tutorials'
                    : `${profileDetails.firstname.trim()}'s Projector`
                  : ''}
              </div>
              {!profileDetails?.firstname && (
                <div className={styles.noNameSubtext}>
                  Make your content more aesthetic by adding a Profile name.
                  {' '}
                  <Link to={Pathname.getSettingsPath('/accounts')} className={styles.updateLink}>
                    Update now
                  </Link>
                </div>
              )}
            </div>
          )}
          {contentData?.length > 0 && loader === false && (
            <div
              className={cn({
                [styles.imageGroup]: true,
                [styles.layoutImageGroup]:
                  (layoutType === 3 || layoutType === 5)
                  && (categoryStyleId === 3 || categoryStyleId === 4),
                [styles.videoBannerImageGroup]:
                  layoutType === 4
                  && (categoryStyleId === 3 || categoryStyleId === 4),
              })}
            >
              <div className={styles.imageGroupImagesWrapper}>
                {/* <div className={styles.imageGroupImagesContainer}> */}
                <div
                  onMouseEnter={() => setArrows(true)}
                  onMouseLeave={() => setArrows(false)}
                  className={cn({
                    [styles.imageGroupImagesContainer]: true,
                    [styles.isGrid]: true,
                  })}
                >
                  <div className={styles.imageGroupImagesWrapper}>
                    {contentData?.length > 4 && (
                      <div className={styles.swiperNavWrapper}>
                        <div
                          // className={styles.swiperButtonPrev}
                          className={cn(styles.swiperButtonPrev, {
                            [styles.hiddenArrow]: swiperStates?.atBeginning,
                          })}
                          id="custom-prev"
                        >
                          <img src={LeftArrowImg} alt="Next" />
                        </div>
                        <div
                          className={cn(styles.swiperButtonNext, {
                            [styles.hiddenArrow]:
                              swiperStates?.atEnd
                              && !categoriPagination?.hasNextPage,
                          })}
                          id="custom-next"
                        >
                          <img src={RightArrowImg} alt="Next" />
                        </div>
                      </div>
                    )}
                    <Swiper
                      style={{ padding: '10px' }}
                      slidesPerView={slidesPerView}
                      spaceBetween={20}
                      breakpoints={{
                        0: {
                          slidesPerView: 3,
                          spaceBetween: 10, // For mobile screens (from 0px up)
                        },
                        640: {
                          slidesPerView: 4,
                          spaceBetween: 20, // For tablets and bigger screens (example: from 640px up)
                        },
                      }}
                      navigation={{
                        prevEl: '#custom-prev',
                        nextEl: '#custom-next',
                      }}
                      slidesPerGroup={2} // ✅ Move 2 slides at a time
                      pagination={false} // ❌ Removes pagination dots
                      modules={[Navigation]}
                      onSlideChange={(swiper) => {
                        updateSwiperStates(swiper);
                        addMoreContents(); // your callback
                      }}
                    >
                      {contentData?.map(
                        (
                          {
                            category_id,
                            category_name,
                            videoPagination,
                            icon,
                            imagekit_icon,
                          },
                          idx
                        ) => (
                          <SwiperSlide
                            key={idx}
                            className={styles.swiperSlideHover}
                          >
                            <div
                              style={{
                                backgroundImage: `linear-gradient(
                                rgba(0, 0, 0, 0.5),
                                rgba(0, 0, 0, 0.5)
                              ),url(${icon})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                fontWeight: '700',
                              }}
                              className={cn({
                                [styles.imageGroupImageLink]: true,
                                [styles.categoryButton]: true,
                                [styles.active]:
                                  selectedCategoryID === category_id,
                                [styles.textAlignFit]: true,
                                [styles.bannerTypeCategoryButton]:
                                  categoryStyleId === 3
                                  || categoryStyleId === 4,
                                [styles.rounded]:
                                  categoryStyleId === 2
                                  || categoryStyleId === 4,
                              })}
                              key={idx}
                              tabIndex="0"
                              role="button"
                              onKeyPress={undefined}
                              onClick={() => {
                                setSelectedCategoryID(category_id);
                                setSelectedCategoryTitle(category_name);
                                setThumbnail(icon);
                                localStorage.setItem(
                                  'prevlocation',
                                  'innerpage'
                                );
                                navigate('/innerpage', {
                                  state: {
                                    category_name,
                                    category_id,
                                    icon,
                                    profile_id: profileID,
                                  },
                                });
                              }}
                            >
                              {category_name}
                            </div>
                          </SwiperSlide>
                        )
                      )}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div>
            {contentData?.length > 0
              || playlistData?.length > 0
              || albumData?.length > 0 ? (
              <>
                {resumeMe?.data && (
                  <ViewMyProjector
                    key="resumeMe"
                    fetchData={fetchResumeData} // your fetch function for resume
                    responseData={resumeMe?.data[0]}
                    isGrid
                    type={CONTENT_TYPES.resume}
                    clearResumeWatching={clearResumeWatching}
                    onShowPermissionModal={() => {
                      console.log('🟡 Profile: Setting modal to true');
                      setShowPermissionModal(true);
                    }}
                  />
                )}
                {profileOrder
                  ?.sort(
                    (a, b) => Number(a?.order_number) - Number(b?.order_number)
                  )
                  ?.map(({ content_type_id }, index) => {
                    const config = contentTypeMap[content_type_id];
                    if (!config) return null;

                    return (
                      <ViewMyProjector
                        key={index}
                        pagination={config.pagination}
                        fetchData={config.fetchData}
                        offset={config.offset}
                        responseData={config.responseData}
                        setVideoOffset={setVideoOffset}
                        isGrid
                        type={config.type}
                        {...(config.albumPagination && {
                          albumPagination: config.albumPagination,
                        })}
                        {...(config.profileDetails && {
                          profileDetails: config.profileDetails,
                        })}
                        onShowPermissionModal={() => {
                          console.log('🟡 Profile: Setting modal to true');
                          setShowPermissionModal(true);
                        }}
                      />
                    );
                  })}
              </>
            ) : (
              <h2
                style={{
                  margin: '0',
                  textAlign: 'center',
                  color: 'white',
                  fontSize: '1.5rem',
                  fontWeight: '500',
                  padding: '10rem',
                }}
              >
                No Content...
              </h2>
            )}
          </div>
        </ProfilePage>
      )}

      {/* Permission Denied Modal */}
      <PermissionDeniedModal
        open={showPermissionModal}
        onClose={() => {
          console.log('🔵 Modal closing');
          setShowPermissionModal(false);
        }}
      />
    </>
  );
};
